export const ABSTRACT_ACTION_TYPES = {
  FIXTURE_DIGITAL_WRITE: 'FIXTURE_DIGITAL_WRITE',
  FIXTURE_TURN_TO: 'FIXTURE_TURN_TO',
  FUNCTION: 'FUNCTION', // Probablement inutile
  PLAY_SFX: 'PLAY_SFX',
  STOP_SFX: 'STOP_SFX',
  SET_VARIABLE: 'SET_VARIABLE',
  PLAY_VIDEO: 'PLAY_VIDEO',
  SET_PAN_SFX: 'SET_PAN_SFX',
  SET_VOLUME_SFX: 'SET_VOLUME_SFX',
  STOP_VIDEO: 'STOP_VIDEO',
  START_PLAYLIST: 'START_PLAYLIST',
  STOP_PLAYLIST: 'STOP_PLAYLIST',
  START_BUNDLE: 'START_BUNDLE',
  STOP_BUNDLE: 'STOP_BUNDLE',
  DISPLAY_TEXT: 'DISPLAY_TEXT',
  SET_STATUS: 'SET_STATUS',
  SET_LANGUAGE: 'SET_LANGUAGE',
  SEND_POD_NETWORK_STRING: 'SEND_POD_NETWORK_STRING',
  SEND_POD_NETWORK_KV: 'SEND_POD_NETWORK_KV',
  SEND_BUNDLE: 'SEND_BUNDLE',
  SEND_BUNDLE_KEY_VALUE: 'SEND_BUNDLE_KEY_VALUE',
  GPIO_FUNCTION_BLINK: 'GPIO_FUNCTION_BLINK',
  GPIO_FUNCTION_TURN_TO: 'GPIO_FUNCTION_TURN_TO',
  TIMER_START: 'TIMER_START',
  TIMER_OPERATION: 'TIMER_OPERATION',
  SEQUENCE_START: 'SEQUENCE_START',
  BLINK_X_TIMES: 'BLINK_X_TIMES',
  WAIT: 'WAIT',
  IF_ACTION: 'IF_ACTION',
  MULTIPLE_ACTION: 'MULTIPLE_ACTION',
  PAD_INPUT_CHECKBOX_ASSIGN_ACTION: 'PAD_INPUT_CHECKBOX_ASSIGN_ACTION',
}